var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_234_363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 48,
    height: 48,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.5,
    width: 47,
    height: 47,
    rx: 15.5,
    stroke: "#F3F4F6",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6651 31.811C36.3781 32.475 36.0381 33.086 35.6441 33.648C35.1071 34.415 34.6661 34.945 34.3281 35.24C33.8031 35.722 33.2391 35.97 32.6361 35.984C32.2041 35.984 31.6821 35.861 31.0741 35.611C30.4641 35.362 29.9041 35.24 29.3911 35.24C28.8541 35.24 28.2781 35.362 27.6611 35.611C27.0451 35.861 26.5471 35.992 26.1661 36.004C25.5891 36.029 25.0121 35.775 24.4371 35.24C24.0701 34.92 23.6111 34.37 23.0601 33.592C22.4701 32.763 21.9851 31.798 21.6051 30.701C21.1981 29.514 20.9941 28.366 20.9941 27.254C20.9941 25.981 21.2691 24.882 21.8201 23.962C22.2541 23.222 22.8301 22.639 23.5501 22.211C24.2711 21.782 25.0511 21.563 25.8901 21.549C26.3501 21.549 26.9531 21.691 27.7001 21.971C28.4471 22.251 28.9271 22.393 29.1361 22.393C29.2941 22.393 29.8251 22.226 30.7291 21.895C31.5821 21.588 32.3021 21.461 32.8921 21.511C34.4921 21.64 35.6931 22.27 36.4921 23.406C35.0621 24.273 34.3551 25.486 34.3691 27.043C34.3811 28.256 34.8221 29.265 35.6861 30.066C36.0781 30.438 36.5151 30.725 37.0011 30.929C36.8951 31.236 36.7831 31.529 36.6651 31.811ZM32.9981 17.38C32.9981 18.33 32.6501 19.218 31.9591 20.039C31.1231 21.015 30.1131 21.58 29.0181 21.491C29.0041 21.377 28.9971 21.257 28.9971 21.131C28.9971 20.218 29.3931 19.242 30.1001 18.443C30.4521 18.039 30.9001 17.702 31.4431 17.434C31.9851 17.17 32.4971 17.024 32.9791 16.999C32.9921 17.127 32.9981 17.254 32.9981 17.38Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_234_363",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.101961 0 0 0 0 0.121569 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_234_363"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.101961 0 0 0 0 0.121569 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_234_363",
    result: "effect2_dropShadow_234_363"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_234_363",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBilling);
export default __webpack_public_path__ + "static/media/apple_billing.07f17f8ed12cc81c3b2e1994b8a6c14f.svg";
export { ForwardRef as ReactComponent };